import { PortalSubAccount, PortalSubAccountsRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchPortalSubAccounts() {
  const [fetching, setFetching] = useState(false);
  const [subAccounts, setSubAccounts] = useState<PortalSubAccount[]>([]);

  async function fetchPortalSubAccounts(params: PortalSubAccountsRequest) {
    try {
      setFetching(true);
      const res = await api.fetchPortalSubAccounts(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setSubAccounts(res.SubAccounts);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, subAccounts, fetchPortalSubAccounts };
}
